import { BASVURU_GECMIS_GETIR } from "../constants/requestUrls";
import { postRequest } from "../request";

const getBasvuruHistory = (props) => {
    let data = {};
    if (props !== undefined)
      data = JSON.stringify(props);
    return postRequest({ url: BASVURU_GECMIS_GETIR, data });
  }

export default getBasvuruHistory;